import React, { useRef, useEffect } from "react";

export const About = () => {
    
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            <section className='container --about shadow default_padding marginTop'>
                <div className='content'>
                    <h1>О нас</h1>
                    <h2>О проекте</h2>
                    <p>МED-NN – это информационно-коммуникационная платформа, задача которой заключается в улучшении взаимодействия между пациентами и медицинскими центрами.</p>
                    <p>Портал предназначен для увеличения доступности медицинской помощи гражданам по Нижегородской области.</p>
                    <p>На портале можно найти познавательные медицинские статьи, новости здоровья и медицины, а также воспользоваться нашими справочной информацией.( расписание работы и списки врачей).</p>
                    <p>Информация на данном сайте носит исключительно справочный (ориентировочный) характер и обновляется по мере поступления изменений. <strong>Более точное расписание спрашивайте в медицинских учреждениях по представленным телефонам.</strong>
                    </p>

                    <h2>Условия сотрудничества</h2>
                    <p>С вопросами по размещению на портале обращайтесь по контактам, которые указаны в разделе ниже.</p>

                    <h2>Наша контактная информация</h2>
                    <p>Контактный телефон для связи: <a href="tel:88004444840">88004444840</a></p>
                    <p>Почта: <a href="mailto:tk.r2.ru@gmail.com">tk.r2.ru@gmail.com</a></p>
                </div>
            </section>
        </>
    );
};